<div
  class="file-upload"
  [class.file-upload--dragging]="isDragging()"
  [class.file-upload--has-file]="selectedFile()"
  [class.file-upload--disabled]="disabled"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  @if (!selectedFile()) {
    <label class="file-upload__zone" [class.file-upload__zone--dragging]="isDragging()">
      <input
        type="file"
        class="file-upload__input"
        [accept]="acceptAttribute"
        [disabled]="disabled"
        (change)="onFileInputChange($event)"
      />
      <div class="file-upload__icon-container">
        <aprova-icon name="cloud-upload-solid" size="32px" />
      </div>
      <p class="file-upload__label" [innerHTML]="label"></p>
      <p class="file-upload__hint">{{ hint }}</p>
    </label>
  } @else {
    <div class="file-upload__preview">
      <div class="file-upload__preview__icon-wrap">
        <aprova-icon name="document-text-solid" size="32px" />
      </div>
      <div class="file-upload__preview__info">
        <p class="file-upload__preview__name">{{ selectedFile()!.name }}</p>
        <p class="file-upload__preview__size">{{ fileSize }}</p>
      </div>
      <button
        type="button"
        class="file-upload__preview__remove"
        (click)="removeFile()"
        aria-label="Remover arquivo"
      >
        <aprova-icon name="trash-outline" size="24px" color="var(--Greyscale-80)" />
      </button>
    </div>
  }
</div>

@if (errorMessage()) {
  <p class="file-upload__error">{{ errorMessage() }}</p>
}
